<template>
  <span :is="type" v-html="computedHtml" v-on="$listeners"></span>
</template>

<script>
export default {
  name: "TextHighlighter",
  props: ["text", "searchText"],
  data() {
    return {
      type: 'div'
    }
  },
  computed: {
    computedHtml() {
      let text = this.text;
      this.type = this.$vnode.data.tag;

      if (!this.searchText)
        return text;

      return text ? text.toString().replace(new RegExp(this.searchText, "gi"), match => {
        return `<span style="background-color: yellow">${match}</span>`
      }) : "";
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/framework/TextHighlighter.vue